angular.module('filters').filter('membershipInitialPaymentFilter', ["$rootScope", "$filter", function($rootScope, $filter) {
  return function(membership) {
    var amount, date, symbol;
    if (membership.cost_upfront > 0) {
      symbol = $rootScope.gym.currency_symbol;
      amount = $filter('currency')(membership.cost_upfront, symbol);
      date = $filter('stringToDate')(membership.upfront_payment_on);
      return `${amount} on ${date}`;
    } else {
      return "No initial payment";
    }
  };
}]);
